/* eslint-disable @typescript-eslint/no-explicit-any */
import app from 'apprun';
import moment from 'moment';
import Pikaday from 'pikaday';
// declare let Pikaday;

import { Lookup } from './api';

export let lookup_en;
export let lookup;

export async function getLookup() {

  if (lookup) {return lookup;}

  lookup = await Lookup.getLookup();

  lookup.en.Title = lookup.en.Title.filter(o => o.value !== '');
  lookup.fr.Title = lookup.fr.Title.filter(o => o.value !== '');

  lookup.en.EmployeeTypeCt.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.SalutationCt.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.Title.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.PreviousAffiliation.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.RecruitmentSource.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });

  lookup.en.RegionsServiced.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.MobileDeviceTypes.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.Designations.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.LanguagesSpoken.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.BusinessTypes.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.Awards.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });

  lookup.en.AdminAwards.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.HighestLevelOfEducation.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });

  lookup.en.ExpertTopic.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.ProvStateCt.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.ReasonForLeaving.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.en.FutureAffiliation.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });

  //console.log(lookup);
  //console.log(lookup.fr.Designations);

  lookup.fr.EmployeeTypeCt.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.SalutationCt.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.Title.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.PreviousAffiliation.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.RecruitmentSource.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.RegionsServiced.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.MobileDeviceTypes.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.Designations.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.LanguagesSpoken.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.BusinessTypes.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.Awards.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });

  lookup.fr.AdminAwards.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.HighestLevelOfEducation.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });

  lookup.fr.ExpertTopic.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.ProvStateCt.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });

  lookup.fr.ReasonForLeaving.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });
  lookup.fr.FutureAffiliation.sort(function (a, b) {
    return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
  });

  lookup_en = lookup.en;
}

// assumes that only authenticated page will use lookup
// if (auth.current()) getLookup();

export function addOptions(lookupName, selectedId) {
  return lookup_en[lookupName].map(r =>
    <option value={r.id} selected={r.id === selectedId ? 'selected' : null}>
      {r.value}
    </option>
  );
}

export function toggleNext(id) {
  document.getElementById(id).classList.toggle('collapsed');
}
interface IDictionary {
  [index: string]: boolean;
}

export function areRequiredFieldsAvailable(state, formName): boolean {
  let retVal = true;
  let errMsg = '';
  const errRequired: IDictionary = {};
  const requiredNodesList = document.getElementById(formName).querySelectorAll('[required]');
  const requiredNodesArray = Array.prototype.slice.call(requiredNodesList, 0);

  requiredNodesArray.forEach((element) => {
    if (element.value.trim() === '') {
      retVal = false;
      errMsg += element.name + ' is required. ';
      errRequired[element.name] = true;
    } else {
      errRequired[element.name] = false;
    }
  });
  state.errRequired = errRequired;
  state.errMsg = errMsg;
  return retVal;
}

export function validateEmail(email): boolean {
  // eslint-disable-next-line no-useless-escape
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validatePhone(phone): boolean {
  //var re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
  const re = /^[0-9]*$/;
  return re.test(String(phone));
}

export function validatePhoneWithDashes(phone): boolean {
  const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
  return re.test(String(phone));
}

export function validateDate(dateStr, format='D-MMM-YYYY'): boolean {
  return moment(dateStr, format, true).isValid();
}
export function validatePostalCode(postalCode): boolean {
  const re = /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/;
  return re.test(String(postalCode.toUpperCase()));
}

export function validateInteger(x): boolean {
  const re = x && !isNaN(Number(x.toString())) && x % 1 === 0;
  return re;
}

export function validateNumber(x): boolean {
  const re = x && !isNaN(Number(x.toString()));
  return re;
}

export function validateMax7dInteger(x): boolean {
  const re = x && !isNaN(Number(x.toString())) && x % 1 === 0 && x.toString().length <= 7;
  return re;
}

export function isValid(formName): boolean {
  let retVal = true;

  const requiredNodesList = document.getElementById(formName).querySelectorAll('[data-validate]');
  const requiredNodesArray = Array.prototype.slice.call(requiredNodesList, 0);
  requiredNodesArray.forEach((element) => {
    const errDiv = document.getElementById(element.id + 'ErrMsg') as HTMLDivElement;

    if (element.value.trim() === '') {
      retVal = false;
      errDiv.innerHTML = '* required';
    } else if (element.getAttribute('data-validate') === 'Int' && isStringEqual(element.value, '0')) {
      retVal = false;
      errDiv.innerHTML = '* required';
    } else if (element.getAttribute('data-validate') === 'Int' && !validateStringType(element.value.trim(), 'Integer')) {
      retVal = false;
      errDiv.innerHTML = '* invalid integer';
    } else if (element.getAttribute('data-validate') === 'Int-1' && isStringEqual(element.value, '-1')) {
      retVal = false;
      errDiv.innerHTML = '* required';
    } else if (element.getAttribute('data-validate') === 'PCode' && !validatePostalCode(element.value.trim())) {
      retVal = false;
      errDiv.innerHTML = '* invalid postal code';
    } else if (element.getAttribute('data-validate') === 'email' && !validateEmail(element.value.trim())) {
      retVal = false;
      errDiv.innerHTML = '* invalid email';
    } else if (element.getAttribute('data-validate') === 'Date' && !validateDate(element.value.trim())) {
      retVal = false;
      errDiv.innerHTML = '* invalid date';
    } else if (element.getAttribute('data-validate') === 'Phone' && !validatePhone(element.value.trim())) {
      retVal = false;
      errDiv.innerHTML = '* invalid phone';
    } else if (
      element.getAttribute('data-validate') === 'Max7dInteger' &&
      !validateMax7dInteger(element.value.trim())
    ) {
      retVal = false;
      errDiv.innerHTML = '* invalid DCS ID';
    } else if (
      element.getAttribute('data-validate') === 'NoDomainEmail' &&
      !validateEmail(element.value.trim() + '@royallepage.ca')
    ) {
      retVal = false;
      errDiv.innerHTML = '* invalid User Name';
    } else {
      errDiv.innerHTML = '';
    }
  });
  return retVal;
}

export function validateStringType(value, type): boolean {
  //console.log('In validateStringType...value=' + value + ", type=" + type);
  let retVal = false;

  switch (type) {
  case 'email':
    retVal = validateEmail(value.trim());
    break;
  case 'DateStr':
    retVal = validateDate(value.trim());
    break;
  case 'Integer':
    retVal = validateInteger(value.trim());
    break;
  case 'Max7dInteger':
    retVal = validateMax7dInteger(value.trim());
    break;
  case 'Number':
    retVal = validateNumber(value.trim());
    break;
  case 'Int-1':
    retVal = validateInteger(value.trim()) && value !== -1;
    break;

  default:
    retVal = true;
    break;
  }

  return retVal;
}

export function isValidElement(elementId, type): boolean {
  let retVal = false;

  const element = document.getElementById(elementId) as HTMLInputElement;
  const errDiv = document.getElementById(element.id + 'ErrMsg') as HTMLDivElement;

  if (validateStringType(element.value.trim(), type)) {
    retVal = true;
    errDiv.innerHTML = '';
  } else {
    retVal = false;
    errDiv.innerHTML = '* invalid value';
  }
  return retVal;
}

export function getLookupValueById(_lookup, id) {
  return _lookup.find(r => id === r.id)?.value;
}

export function showSaveStatusMessage(serverResult=null) {
  if (serverResult) {
    app.run('show-message', `${serverResult} saved...👍✌️😎`, 10000);
  } else {
    app.run('show-message', 'failed... ❌❌❌ ⁉️', 10000);
  }
}

export function formatPhoneNumber(input) {

  if (input?.length >= 11) {return input.substring(0, 1) + '-' + formatPhoneNumber(input.substring(1));}
  if (input?.length >= 10) {return input.substring(0, 3) + '-' + input.substring(3, 6) + '-' + input.substring(6);}
  return input;
}

export function formatTollFreePhoneNumber(input) {
  return input?.length >= 11
    ? input.substring(0, 1) + '-' + formatPhoneNumber(input.substring(1))
    : formatPhoneNumber(input);
}

export const setDisabledButton = (btn, on = true) => {
  if (!btn) { return; }
  btn.disabled = on;

  if (on) {btn.classList.add('disabled');} else {btn.classList.remove('disabled');}
};

const DatePicker = () => (field) => {
  field['pik'] && field['pik'].destroy();
  field['pik'] = new Pikaday({
    format: 'DD-MMM-YYYY',
    field,
    onSelect: () => field.dispatchEvent(new Event('input'))
  });
};

app.on('$', ({ key, props }) => {
  key === '$pikaday' && (props.ref = DatePicker());
});

export function isStringEqual(str1, str2) {
  if(typeof str1 === 'number' && typeof str2 === 'string'){
    return Number(str1).toString() === str2;
  }

  if(typeof str1 === 'string' && typeof str2 === 'number'){
    return Number(str2).toString() === str1;
  }

  if (typeof str1 === 'boolean' && typeof str2 === 'string') {
    return str1.toString() === str2;
  }

  if (typeof str1 === 'string' && typeof str2 === 'boolean') {
    return str2.toString() === str1;
  }

  if(typeof str1 !== typeof str2) {return false;}

  if(str1 && str2){
    return str1.toString().localeCompare(str2.toString(), undefined, { sensitivity: 'accent' }) === 0;
  } else if(!str1 && str2){
    return false;
  } else if(str1 && !str2){
    return false;
  } else{
    if(isNaN(str1) && isNaN(str2)){ return true;}
    return str1 === str2;
  }

}

export function dateRangeOverlaps(a_start, a_end, b_start, b_end) {
  if (a_start <= b_start && b_start <= a_end) {return true;} // b starts in a
  if (a_start <= b_end   && b_end   <= a_end) {return true;} // b ends in a
  if (b_start <  a_start && a_end   <  b_end) {return true;} // a in b
  return false;
}

export function dateInRange(a, b_start, b_end) {
  if (b_start <=  a && a <=  b_end) {return true;} // a in b
  return false;
}

export function isDateRangeOverlap(start, end, dateRanges) {
  for (const val of dateRanges) {
    if(dateRangeOverlaps(start, end, val.startDate, val.endDate)){
      return true;
    }
  }
  return false;
}

export function isDateInRange(d, dateRanges) {
  for (const val of dateRanges) {
    if(isDateRangeOverlap(d, val.startDate, val.endDate)){
      return true;
    }
  }
  return false;
}